export default {
    panelGroupLoading: state => state.panelGroupLoading,
    panelGroupsListLoading: state => state.panelGroupsListLoading,
    panelGroupsList: state => state.panelGroupsList,
    panelGroupsPosition: state => state.panelGroupsPosition,
    panelGroupsPosLoading: state => state.panelGroupsPosLoading
}